import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { setFamilyFormAction } from './store/family-form.actions';
import { IFamilyFormState } from './store/family-form.state';
import { getFamilyFormSelectorsState } from './store/family-form.selectors';
import { IFamilyData } from 'src/app/modules/interfaces/spouses.interface';
import { FamilyService } from 'src/app/services/spouses.service';
import { getCookie } from 'src/app/utils/get-cookie';

@Component({
  selector: 'app-family-form',
  templateUrl: './family-form.component.html',
  styleUrls: ['./family-form.component.scss'],
})
export class FamilyFormComponent implements OnInit {
  @Output() formSaved = new EventEmitter<void>();
  formsId: number;
  familyData: IFamilyData = {
    id: 0,
    has_spouse: null,
    has_dependents: null,
    invest_in_future: null,
  };

  isSaving = false;
  saveButtonText = 'Salvar';
  saveButtonClass = 'btn-primary';

  dataState$: Observable<IFamilyFormState>;
  dataState: IFamilyFormState;

  isLoading = true;

  constructor(private store: Store, private familyService: FamilyService) {
    this.formsId = Number(getCookie('formsId'));
  }

  ngOnInit(): void {
    this.getState();
    this.loadFamilyData();
  }

  loadFamilyData(): void {
    this.isLoading = true
    this.familyService.getFamilyData(this.formsId).subscribe((response) => {
      if (response) {
        this.familyData = {
          id: response.id,
          has_spouse: response.has_spouse,
          spouse_notes: response.spouse_notes || '',
          has_dependents: response.has_dependents,
          dependents_notes: response.dependents_notes || '',
          invest_in_future: response.dependents?.invest_in_future || 0,
          invest_notes: response.dependents?.invest_notes || '',
        };
        this.saveState()
      }
    });
  }

  saveForm(): void {
    this.isSaving = true;
    this.saveButtonText = 'Salvando...';
    this.saveButtonClass = 'btn-secondary';

    const updateData: any = {
      has_spouse: this.familyData.has_spouse,
      has_dependents: this.familyData.has_dependents,
    };

    if (this.familyData.spouse_notes) {
      updateData.spouse_notes = this.familyData.spouse_notes;
    }
    if (this.familyData.dependents_notes) {
      updateData.dependents_notes = this.familyData.dependents_notes;
    }
    if (this.familyData.invest_in_future !== null) {
      updateData.invest_in_future = this.familyData.invest_in_future;
    }

    if (this.familyData.invest_in_future === 1) {
      updateData.invest_notes = this.familyData.invest_notes || '';
    } else {
      delete updateData.invest_notes;
    }

    this.familyService
      .updateFamilyData(this.formsId, this.familyData.id, updateData)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.saveButtonText = 'Salvo';
          this.saveButtonClass = 'btn-primary';
          this.saveState()
          this.formSaved.emit();
        
        },
        error: (err) => {
          this.isSaving = false;
          this.saveButtonText = 'Erro ao salvar';
          this.saveButtonClass = 'btn-danger';
          console.error('Erro ao atualizar os dados da família', err);
        },
      });
  }

  saveState(): void {
    this.dataState = {
      ...this.dataState,
      check: true,
      married: {
        isSelected: this.familyData.has_spouse === 1,
        notes: this.familyData.spouse_notes || '',
      },
      children: {
        isSelected: this.familyData.has_dependents === 1,
        notes: this.familyData.dependents_notes || '',
      },
      childrenInvestment: {
        isSelected: this.familyData.invest_in_future === 1,
        notes: this.familyData.invest_notes || '',
      },
    };

    this.setState(this.dataState);
  }

  onFieldChange(): void {
    if (!this.isSaving) {
      this.saveButtonText = 'Salvar';
      this.saveButtonClass = 'btn-primary';
    }
  }

  setState(data) {
    this.store.dispatch(setFamilyFormAction(data));
    this.isLoading = false
  }

  getState() {
    this.dataState$ = this.store.select(getFamilyFormSelectorsState);
    this.dataState$.subscribe((value) => {
      this.dataState = {
        ...(this.dataState = value),
      };
    });
  }

  setValuesForm(): void {
    this.dataState.check = false;
    if (
      this.dataState.married.isSelected != undefined &&
      this.dataState.children.isSelected != undefined &&
      this.dataState.childrenInvestment.isSelected != undefined
    ) {
      this.dataState.check = true;
    }
    this.setState(this.dataState);
  }

  setOption(item: string, option: string, value: boolean) {
    // Criar uma cópia do estado atual
    this.dataState = {
      ...this.dataState,
      [item]: {
        ...this.dataState[item],
        [option]: value,
      },
    };

    // Atualizar o estado usando o método `setState`
    this.setState(this.dataState);
  }
}
